import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { customerShape } from 'constants/propTypes';
import { COVID_VOUCHER_REFUND, MARGIN_REFUND } from 'constants/payment';
import Currency from 'utils/Currency';

import { CashInput } from 'components/ui/Inputs';
import ValidationForm from 'components/ui/ValidationForm';

import { ADD_NOTE_TO_BOOKING } from 'store/mutations';
import { useMutation } from '@apollo/client';
import SplitPayment from '../../SplitPayment';
import { handleRefundSubmit } from '../../SplitPayment/SplitPayment.utils';
import { Errors } from '../../SplitPayment/SplitPayment.styles';

const CashRefund = ({
  loading,
  totalPriceToBePaid,
  addPayment,
  addPayoutAndBalance,
  updatePayments,
  customer,
  reference,
  bookingReference,
  currency,
  method,
  isCancelVoucher,
  mainBookingRef,
  isOverpaid = false
}) => {
  const [addNote] = useMutation(ADD_NOTE_TO_BOOKING);

  return (
    <ValidationForm
      fields={{ amount: totalPriceToBePaid }}
      validators={{
        amount: (values) => Number(values.amount) !== 0
      }}
    >
      {({ fields: { amount }, onChange, invalidInputs, hasInvalidInputs }) => (
        <SplitPayment
          title={<FormattedMessage id="payments.AmountToRefundByCash" />}
          subTitle={<FormattedMessage id="refunds.canBeSplit" />}
          label={<FormattedMessage id="refunds.recordRefund" />}
          loading={loading}
          onSubmit={(e) => {
            e.preventDefault();

            const completeTransaction = amount >= totalPriceToBePaid - MARGIN_REFUND;

            handleRefundSubmit({
              membershipNumber: null,
              completeTransaction,
              paymentAmount: amount,
              totalPriceToBePaid,
              addPayoutAndBalance,
              updatePayments,
              addPayment,
              customer,
              bookingReference,
              reference,
              currency,
              method,
              isOverpaid
            });

            if (isCancelVoucher) {
              addNote({
                variables: {
                  note: `${COVID_VOUCHER_REFUND}, main booking: ${mainBookingRef}, extra only booking: ${bookingReference}`,
                  bookingReference: mainBookingRef
                }
              });

              addNote({
                variables: {
                  note: `${COVID_VOUCHER_REFUND}, main booking: ${mainBookingRef}, extra only booking: ${bookingReference}`,
                  bookingReference
                }
              });
            }
          }}
          disabled={hasInvalidInputs}
        >
          <CashInput
            showChange={false}
            name="amount"
            value={amount}
            placeHolder={0}
            currency={currency}
            onChange={onChange}
            changeDue={Currency.subtract(amount, totalPriceToBePaid)}
          />
          <Errors>{invalidInputs.amount && <FormattedMessage id="payments.amountZero" />}</Errors>
        </SplitPayment>
      )}
    </ValidationForm>
  );
};

CashRefund.propTypes = {
  bookingReference: PropTypes.string,
  totalPriceToBePaid: PropTypes.number,
  loading: PropTypes.bool,
  addPayment: PropTypes.func,
  addPayoutAndBalance: PropTypes.func,
  updatePayments: PropTypes.func,
  customer: customerShape,
  reference: PropTypes.string,
  currency: PropTypes.string,
  method: PropTypes.string,
  isCancelVoucher: PropTypes.bool,
  mainBookingRef: PropTypes.string,
  isOverpaid: PropTypes.bool
};

export default CashRefund;
